module.exports = __webpack_public_path__ + "static/assets/27a1dd1c199eebbd05069b0287c1d48c.gif";